module.exports = __webpack_public_path__ + "img/moGaoKu5.b810dd38.png";